import { Injectable } from '@angular/core';
import { Platform } from 'ionic-angular';
import { NativeAudio } from '@ionic-native/native-audio';

/* This provider manages audio, music and sound effect */

@Injectable()
export class SmartAudio {

  audioType: string = 'html5';
  sounds: any = [];
  currentBgMusic:any;
  soundEffectIsActive: number = 1; // needs to stay here for putting it in functions created a circular dependency
  volume:number;
  musicIsActive: number = 1;
 
  constructor(public nativeAudio: NativeAudio, platform: Platform) {
    if(platform.is('cordova')){
      this.audioType = 'native';
    }
    if (!platform.is('core')) {
      this.globalDisableMusic();
      this.globalDisableSoundEffects()
    }
    this.currentBgMusic = new Audio();
  }

  globalDisableMusic(){
    this.musicIsActive=0;
    this.volume=0;
  }

  globalEnableMusic(){
    this.musicIsActive=1;
    this.volume=20;
  }    

  globalDisableSoundEffects(){
    this.soundEffectIsActive=0;
  }

  globalEnableSoundEffects(){
    this.soundEffectIsActive=1;
  }
    
  getCurrentVolume(){
    return this.volume/100;
  }

  /* Manage sound effects */ 
  preloadSimple(key, asset) { //cannot be stopped or looped
    if (this.soundEffectIsActive==1) {
      if(this.audioType === 'html5'){
          let audio = {
              key: key,
              asset: asset,
              type: 'html5'
          };
          this.sounds.push(audio);
      } else {
          this.nativeAudio.preloadSimple(key, asset);
          let audio = {
              key: key,
              asset: asset,
              type: 'native'
          };
          this.sounds.push(audio);
      }        
    }else{
      console.log("Preload: Sound Effects DISABLED!");
    }     
  }
 
  play(key){
    if(this.soundEffectIsActive==1){
      let audio = this.sounds.find((sound) => {
        return sound.key === key;
      });
   
      if (audio) {
        if(audio.type === 'html5'){ 
          let audioAsset = new Audio(audio.asset);
          audioAsset.play();
        } else { 
          this.nativeAudio.play(audio.key).then((res) => {
            //console.log(res);
            }, (err) => {
            console.log("ERROR: "+err);
          });
        }
      }
    }else{
      console.log("Play: Sound Effects DISABLED!");
    }  
  }
    
  /* Manage Background Music */
  preloadComplex(key, asset, volume, voices, delay) {
    if(this.musicIsActive==1){
      if(this.audioType === 'html5'){
        let audio = {
          key: key,
            asset: asset,
            type: 'html5'
        };
        this.sounds.push(audio);
      } else {
        this.nativeAudio.preloadComplex(key, asset, volume, voices, delay);
        let audio = {
            key: key,
            asset: asset,
            type: 'native'
        };
        this.sounds.push(audio);
      }  
    }else{
      console.log("Preload: Music DISABLED!");
    }  
  }

  setBgVolume(key){
    if(this.musicIsActive==1){
      let audio = this.sounds.find((sound) => {
        return sound.key === key;
      });
      if (audio) {
        if(audio.type === 'html5'){ 
          this.currentBgMusic.volume=this.getCurrentVolume();
        } else { 
          this.nativeAudio.setVolumeForComplexAsset(audio.key, this.getCurrentVolume());
        }
      }
    }else{
      console.log("SetBgVolume: Music DISABLED!");
    }  
  }

  startBgMusic(key){
    if(this.musicIsActive==1){
      let audio = this.sounds.find((sound) => {
        return sound.key === key;
      });
  
      if (audio) {
        if(audio.type === 'html5'){ 
          this.currentBgMusic = new Audio(audio.asset);
          this.currentBgMusic.loop=true;
          this.currentBgMusic.volume=this.getCurrentVolume();
          this.currentBgMusic.play();
        } else { 
          this.nativeAudio.loop(audio.key).then((res) => {
          //console.log(res);
            }, (err) => {
            console.log("ERROR: "+err);
          });
        }
      }
    }else{
      console.log("startBgMusic: Music DISABLED!");
    } 
  }

  stopBgMusic(key){
    if(this.musicIsActive==1){
      let audio = this.sounds.find((sound) => {
        return sound.key === key;
      });
  
      if (audio) {
        if(audio.type === 'html5'){ 
          if (this.currentBgMusic.currentTime) {
            this.currentBgMusic.currentTime=0;
            this.currentBgMusic.pause();
          }
        } else { 
          this.nativeAudio.stop(audio.key).then((res) => {
            //console.log(res);
            }, (err) => {
            console.log("ERROR: "+err);
          });
        }
      }
    }else{
      console.log("stopBgMusic: Music DISABLED!");
    } 
  }

  changeVolumeApp(){
    if(this.musicIsActive==1){
      this.setBgVolume('app_BgMusic');

      this.setBgVolume('game_1_BgMusic');
      this.setBgVolume('game_2_BgMusic');
      this.setBgVolume('game_3_BgMusic');
      this.setBgVolume('game_4_BgMusic');
      this.setBgVolume('game_5_BgMusic');
      this.setBgVolume('game_6_BgMusic');

      this.setBgVolume('game_youLost');
      this.setBgVolume('game_youWin');

    }else{
      console.log("changeVolumeApp: Music DISABLED!");
    } 
  }

  changeSoundEffectsStatus(value){
    this.soundEffectIsActive=value;
  }
}



// WEBPACK FOOTER //
// ./src/providers/smart-audio.ts